import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { setCreatorsMetadata } from "src/redux";
import { ToolbarListItem } from "../ToolbarListItem/ToolbarListItem";
import { sortGridElementsByLabel } from "../../functions/sortGridElementsByName";

export const ToolbarListCreatorMetaFields = ({
  format,
  campaignId,
  toolbarListProps,
}) => {
  const {
    reportReducer: { creatorsMetadata, gridElements, hiddenGridElements },
  } = useSelector((state) => state);

  const metadata = creatorsMetadata[campaignId] || [];
  const allElements = [...gridElements, ...hiddenGridElements];

  const creators = allElements
    .filter(
      (item) =>
        item.gridBoxType === "creator" && item.campaignId === campaignId,
    )
    .map((item) => ({
      label: item.title,
      value: item.label,
      campaignId: item.campaignId,
    }))
    .sort((a, b) => sortGridElementsByLabel(a, b));

  const dispatch = useDispatch();

  const toggleFieldVisibility = (newValue, uuid) => {
    const newCreatorsMetadata = metadata.map((item) => {
      if (item.uuid === uuid) {
        return {
          ...item,
          reportVisible: newValue,
        };
      }
      return item;
    });

    dispatch(setCreatorsMetadata(campaignId, newCreatorsMetadata));
  };

  return (
    <>
      <div className="toolbar-list__list-item">
        <IDHFormattedMessage id="ws_creators" defaultMessage="Creators" />
      </div>
      {creators?.map((item) => (
        <ToolbarListItem
          key={item.value}
          item={item}
          provider="creator"
          format={format}
          toolbarListProps={toolbarListProps}
          isReport
        />
      ))}

      <div className="toolbar-list__list-item">
        <IDHFormattedMessage id="ws_attributes" defaultMessage="Attributes" />
      </div>
      {metadata.map((item) => (
        <div className="toolbar-list__list-item">
          <CustomCheckbox
            id={item.uuid}
            checked={item.reportVisible}
            onChange={() =>
              toggleFieldVisibility(!item.reportVisible, item.uuid)
            }
          />
          {item.name}
        </div>
      ))}
    </>
  );
};
